export const now = () => new Date();
export const unix = (date = now()) => Math.floor(date.getTime() / 1000);
export const unixToDate = (unix = this.unix()) => new Date(unix * 1000);
export const dateString = (date = now()) => date.toLocaleDateString('de-DE', { year: "numeric", month: "2-digit", day: "2-digit" });
export const unixToDateString = (unix = this.unix()) => dateString(unixToDate(unix));